var objectConstructor = {}.constructor;
export default function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}
//# sourceMappingURL=isObject.js.map


// WEBPACK FOOTER //
// ./~/libphonenumber-js/es6/helpers/isObject.js